import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { SearchPaidListMembers } from '@/connection/audiences/paid-lists';

export const searchPaidListMembers = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async ({ paidList, offset, search }: { paidList: string; offset: number; search: string }) => {
      return await SearchPaidListMembers(paidList, offset, search);
    },
    {
      pending: (state) => {
        state.loadingPaidListMembers = true;
      },
      fulfilled: (state, action) => {
        state.paidListMembers = action.payload;
      },
      settled: (state) => {
        state.loadingPaidListMembers = false;
      },
    }
  );
